import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const { ADMIN_BG_COLOR, ADMIN_TEXT_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: ADMIN_BG_COLOR,
    color: ADMIN_TEXT_COLOR,
    paddingTop: 20,
    paddingLeft: 245
  },
  content: {
    paddingTop: 50
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/adminalerts/AdminAlerts.styles.js